// services/everpro/everpro-order/awb.ts â€” generate AWB per-brand via S2 proxy

import { withRetry } from '../../../utils/retryLogic';
import { everproFetch } from '../everpro-auth';
import type { GenerateBulkAwbItem } from '../everpro-types';


export async function generateAWB(clientOrderNo: string, brandId: string): Promise<void> {
  if (!brandId) throw new Error('Everpro: brandId wajib');

  // AWB butuh propagasi sepersekian detik setelah create — 400/404 awal itu JINAK
  // (insiden "semua awalnya error 400" 2026-10-02). Retry 3x jeda 2s; error validasi
  // asli tetap dilempar setelah retry habis.
  let lastMessage = '';
  for (let attempt = 0; attempt < 3; attempt++) {
    if (attempt > 0) await new Promise(r => setTimeout(r, 2000));
    let res: Response;
    try {
      res = await everproFetch(
        brandId,
        `/shipment/v1/orders/${encodeURIComponent(clientOrderNo)}/generate`,
        { method: 'POST' },
      );
    } catch {
      continue;
    }
    if (res.ok) return;
    const detail = await res.text().catch(() => '');
    let message = '';
    // Proxy S2 mengirim pesan error Everpro di field `error` (bukan `message`).
    // Tanpa baca `error`, "already has AWB Number" tak dikenali → 400 diulang 3x
    // tiap booking (sumber spam 400 console, insiden 2026-10-06).
    try { const j = JSON.parse(detail); message = j?.message || j?.error || ''; } catch { /* */ }
    // "already has AWB Number" = generate duluan sukses — BUKAN error, AWB sudah terbit.
    if (message && message.toLowerCase().includes('already has awb')) return;
    lastMessage = message || `Everpro generate AWB: ${res.status} ${res.statusText}`;
    if (res.status !== 400 && res.status !== 404) throw new Error(lastMessage);
  }
  throw new Error(lastMessage || 'Everpro generate AWB gagal');
}



export async function generateBulkAWB(items: GenerateBulkAwbItem[], brandId: string): Promise<void> {
  if (!brandId) throw new Error('Everpro: brandId wajib');

  const res = await withRetry(() => everproFetch(brandId, '/shipment/v1/orders/generate-bulk-awb', {
    method: 'POST',
    body: JSON.stringify(items),
  }), {
    maxRetries: 2,
    initialDelayMs: 1000,
    backoffMultiplier: 2,
    shouldRetry: (err) => {
      if (err instanceof TypeError) return true;
      return false;
    },
  });

  if (!res.ok) {
    const detail = await res.text().catch(() => '');
    let message = '';
    try { message = JSON.parse(detail).message || ''; } catch { /* */ }
    throw new Error(message || `Everpro generate bulk AWB: ${res.status} ${res.statusText}`);
  }
}
